export function ownerDocument(node: Node | null | undefined): Document {
    return (node && node.ownerDocument) || document;
}

export function ownerWindow(node: Node | undefined): Window {
    const doc = ownerDocument(node);
    return doc.defaultView || window;
}

export function getScrollbarSize(doc: Document): number {
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

export function inDOM(): boolean {
    return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
}

export function getOuterHeight(element: HTMLElement): number {
    let height: number = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
}

export const getActiveElement = (root: Document | ShadowRoot = document): Element | null => {
    const activeEl = root.activeElement;
    if (!activeEl) {
        return null;
    }
    if (activeEl.shadowRoot) {
        return getActiveElement(activeEl.shadowRoot);
    }
    return activeEl;
};
